// This extends Leaflet with the Google layer extensions
import mutant from 'leaflet.gridlayer.googlemutant';

let _baseMaps = {};
let _layersInitialized = false;

// TODO: Get zoom, attribution, etc
const googleLayers = [
  { displayLabel: 'Map', type: 'roadmap' },
  { displayLabel: 'Satellite', type: 'hybrid' },
  { displayLabel: 'Terrain', type: 'terrain' },
];

// Disable POI markers
const styles = [
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
];

export function getOverlayDefinitions(control) {
  if (!control?._layers) {
    return {};
  }

  return control._layers.reduce((overlays, definition) => {
    if (definition.overlay) {
      overlays[definition.name] = definition.layer;
    }
    return overlays;
  }, {});
}

// Update layers control after Google Maps loads
function updateLayersControl() {
  const canvas = window.__LP_map;
  if (!canvas?.map?._ctrlPanel) return;

  const map = canvas.map;
  const overlays = getOverlayDefinitions(map._ctrlPanel);

  map.removeControl(map._ctrlPanel);
  map._ctrlPanel = new L.control.layers(_baseMaps, overlays, {
    position: 'topright',
  }).addTo(map);

  // Add default layer if available (needed when Google Maps loads after map initialization)
  const defaultLayer = localStorage.getItem('cn.lp.mapLayer') || 'Map';
  if (_baseMaps[defaultLayer]) {
    _baseMaps[defaultLayer].addTo(map);
  } else if (_baseMaps['Map']) {
    _baseMaps['Map'].addTo(map);
  }
}

// Initialize Google layers if window.google is available
function initializeLayers() {
  if (_layersInitialized || !window.google?.maps) return;

  googleLayers.forEach(({ displayLabel, type }) => {
    _baseMaps[displayLabel] = L.gridLayer.googleMutant({
      type,
      displayLabel,
      styles,
    });
  });

  _layersInitialized = true;
  updateLayersControl();
}

// Export baseMaps - it will be populated when initializeLayers() is called
// The map code should call initializeLayers() after Google Maps loads
export const baseMaps = _baseMaps;

// Export initialization function for explicit initialization
export { initializeLayers };
